<template>
	<div>
		<div id="mapid" @click="select"></div>
	</div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";

export default {
    name: "map-area",
	components: {
  },
  //Doe: เพิ่ม มุด map 1/3
  props:{
    latlon: {
		// type:Object,
		lat: String,
		lon: String,
		
	},
	PAT : Object,
	FSS : Object
  },
  //Doe: เพิ่ม มุด map 1/3 จบ
	data() {
		return{
			map: null,
			point: null,
			lat : '',
			lon : '',
			latlonRetrun : "",
        }
	},
	watch:{
		async latlonRetrun(data){
			// console.log(data)
			this.$emit('selectMap',data);
				await this.axios
				.get(
					`https://api.deemap.com/service/geocode/lat=${data.lat}/lon=${data.lng}/key=0feb00d7e64c5686bf434b9b90ab2d3c`
				)
				.then((response) => {
					// console.log(response.data.data)
					// debugger;
					if (response.data.data.length > 0) {
					this.event_location =
						response.data.data[0].TAM_TNAME +
						" " +
						response.data.data[0].AMP_TNAME +
						" " +
						response.data.data[0].PROV_TNAME +
						" " +
						response.data.data[0].POSTCOD;
					this.event_location_id = response.data.data[0].ADMIN_CODE.slice(-6);
					//   console.log("this.event_location_id =",this.event_location_id);
					//   console.log(this.event_location);
					this.point.clearLayers();
					
					// L.marker(e.latlng).addTo(this.point).bindPopup(`ละติจูด : ${e.latlng.lat}`+'<br>'+`ลองจิจูด : ${e.latlng.lng}`+'<br>'+`สถานที่ : ${this.event_location}`).openPopup();
					L.marker(data).addTo(this.point).bindPopup(`ละติจูด : ${parseFloat(data.lat).toFixed(6)}`+'<br>'+`ลองจิจูด : ${parseFloat(data.lng).toFixed(6)}`+'<br>'+`สถานที่ : ${this.event_location}`).openPopup();

					const PAT_map = {
									"ADMIN_CODE":response.data.data[0].ADMIN_CODE,
									"provinceName" : response.data.data[0].PROV_TNAME,
									"amphurName" : response.data.data[0].AMP_TNAME,
									"tambonName" : response.data.data[0].TAM_TNAME,
									"postCODE" : response.data.data[0].POSTCOD
								}
								// console.log("PAT_map2222",PAT_map)
								this.$emit('selectMap_PAT',PAT_map);

					}
					});
		}
	},
	created() {
	},
	async mounted() {
		
		//Doe: เพิ่ม มุดmap 2/3
		var latZoom =  "";
		var lonZoom =  "";
		if(this.latlon.lat == "" || this.latlon.lat == "null" || this.latlon.lat == null || 
			this.latlon.lon == "" || this.latlon.lon == "null" || this.latlon.lon == null){
			latZoom =  "13.736717"
			lonZoom =  "100.523186"
		}else if (this.latlon.lat != ""){
			latZoom = this.latlon.lat
			lonZoom = this.latlon.lon
		}
		this.map = L.map('mapid').setView([latZoom, lonZoom], 13);
		L.tileLayer.wms("https://www.deemap.com/DeeMap/gwc/service/wms?customer_key=6896c5d543cd914c", {  
			layers: 'DeeMap2_THA_Map',
			format: 'image/png8',
			transparent: true,
		}).addTo(this.map);
		//Doe: เพิ่ม มุดmap 2/3 จบ

		this.point = L.layerGroup().addTo(this.map);
		setTimeout(function () {
		window.dispatchEvent(new Event("resize"));
		}, 200);
		
		await this.searchZoom()
		
	},
	methods: {
		select(){
			this.map.on('click', (e) => {
				this.latlonRetrun = e.latlng
			
			}); return this.latlonRetrun	
		},
		async searchZoom(){
				// เพิ่ม มุดmap 3/3
				// console.log("receive",this.latlon)
				
				if(this.latlon.lat == "" || this.latlon.lat == "null" || this.latlon.lat == null || 
					this.latlon.lon == "" || this.latlon.lon == "null" || this.latlon.lon == null){

					const url = "https://service.deemap.com/service/gismis/boundary/geojson"

					if (this.FSS.fs_tname) {
						await this.axios.post(url,{
								"key":"78e731027d8fd50ed642340b7c9a63b3",
								"topic": "fireStation",
								"type":"point",
								"name":this.FSS.fs_tname
							})
							.then((response) => {
								let getData = response.data.data
								
								this.point.clearLayers();

								const lon = getData.features[0].geometry.coordinates[0];
								const lat = getData.features[0].geometry.coordinates[1];
								// const FSS_name = getData.features[0].properties.fireStation_nameTH
								const PAT_Tambon = this.FSS.tambon_name
								const PAT_Amphoe = this.FSS.amphur_name
								const PAT_province = this.FSS.province_name
								const FSS_post = this.FSS.postcode

								const PAT = `${PAT_Tambon} ${PAT_Amphoe} ${PAT_province} ${FSS_post}`

								L.marker([lat,lon]).addTo(this.point).bindPopup(`ละติจูด : ${parseFloat(lat).toFixed(6)}`+'<br>'+`ลองจิจูด : ${parseFloat(lon).toFixed(6)}`+'<br>'+`สถานที่ : ${PAT}`).openPopup()

								this.map.setView([lat,lon], 13);
								const latlon = {lat:lat,lng:lon}
								this.$emit('selectMap',latlon);

							})
					}
					else if (this.PAT.tambon_name) {
						await this.axios.post(url,{
								"key":"78e731027d8fd50ed642340b7c9a63b3",
								"topic": "tambon",
								"type":"point",
								"id":this.PAT.tambon_id
							})
							.then((response) => {
								let getData = response.data.data
								
								this.point.clearLayers();

								const lon = getData.features[0].geometry.coordinates[0];
								const lat = getData.features[0].geometry.coordinates[1];
								const PAT_Tambon = getData.features[0].properties.tambon_nameTH
								const PAT_Amphoe = getData.features[0].properties.amphoe_nameTH
								const PAT_province = getData.features[0].properties.province_nameTH
								const PAT_tambon_id = getData.features[0].properties.tambon_id
								const PAT = `${PAT_Tambon} ${PAT_Amphoe} ${PAT_province} ${PAT_tambon_id}`

								// const getPAT = L.geoJSON(getData,{
								// onEachFeature: function (feature, layer) {
								// 	layer.bindPopup(`ละติจูด : ${parseFloat(lat).toFixed(6)}`+'<br>'+`ลองจิจูด : ${parseFloat(lon).toFixed(6)}`+'<br>'+`สถานที่ : ${PAT}`).openPopup()
								// }
								// })
								// getPAT.addTo(this.point)

								L.marker([lat,lon]).addTo(this.point).bindPopup(`ละติจูด : ${parseFloat(lat).toFixed(6)}`+'<br>'+`ลองจิจูด : ${parseFloat(lon).toFixed(6)}`+'<br>'+`สถานที่ : ${PAT}`).openPopup()

								this.map.setView([lat,lon], 13);
								const latlon = {lat:lat,lng:lon}
								this.$emit('selectMap',latlon);

							})
							
					}else if(this.PAT.amphur_name){
						await this.axios.post(url,{
								"key":"78e731027d8fd50ed642340b7c9a63b3",
								"topic": "amphoe",
								"type":"point",
								"id":this.PAT.amphur_id
							})
							.then((response) => {
								let getData = response.data.data
								
								this.point.clearLayers();

								const lon = getData.features[0].geometry.coordinates[0];
								const lat = getData.features[0].geometry.coordinates[1];
								const PAT_Tambon = getData.features[0].properties.tambon_nameTH ? getData.features[0].properties.tambon_nameTH : ""
								const PAT_Amphoe = getData.features[0].properties.amphoe_nameTH
								const PAT_province = getData.features[0].properties.province_nameTH
								const PAT_tambon_id = getData.features[0].properties.tambon_id ? getData.features[0].properties.tambon_id : ""
								const PAT = `${PAT_Tambon} ${PAT_Amphoe} ${PAT_province} ${PAT_tambon_id}`

								L.marker([lat,lon]).addTo(this.point).bindPopup(`ละติจูด : ${parseFloat(lat).toFixed(6)}`+'<br>'+`ลองจิจูด : ${parseFloat(lon).toFixed(6)}`+'<br>'+`สถานที่ : ${PAT}`).openPopup()
		
								this.map.setView([lat,lon], 13);
								const latlon = {lat:lat,lng:lon}
								this.$emit('selectMap',latlon);

							})
					}else if(this.PAT.province_name){
						await this.axios.post(url,{
								"key":"78e731027d8fd50ed642340b7c9a63b3",
								"topic": "province",
								"type":"point",
								"id":this.PAT.province_id
							})
							.then((response) => {
								let getData = response.data.data
								
								this.point.clearLayers();

								const lon = getData.features[0].geometry.coordinates[0];
								const lat = getData.features[0].geometry.coordinates[1];
								const PAT_Tambon = getData.features[0].properties.tambon_nameTH ? getData.features[0].properties.tambon_nameTH : ""
								const PAT_Amphoe = getData.features[0].properties.amphoe_nameTH ? getData.features[0].properties.amphoe_nameTH: ""
								const PAT_province = getData.features[0].properties.province_nameTH
								const PAT_tambon_id = getData.features[0].properties.tambon_id ? getData.features[0].properties.tambon_id : ""
								const PAT = `${PAT_Tambon} ${PAT_Amphoe} ${PAT_province} ${PAT_tambon_id}`

								L.marker([lat,lon]).addTo(this.point).bindPopup(`ละติจูด : ${parseFloat(lat).toFixed(6)}`+'<br>'+`ลองจิจูด : ${parseFloat(lon).toFixed(6)}`+'<br>'+`สถานที่ : ${PAT}`).openPopup()
		
								this.map.setView([lat,lon], 13);
								const latlon = {lat:lat,lng:lon}
								this.$emit('selectMap',latlon);

							})
					}
					
				}
				else {
						
					await this.axios
					.get(
						`https://api.deemap.com/service/geocode/lat=${this.latlon.lat}/lon=${this.latlon.lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`
					)
					.then((response) => {
						
						// debugger;
						if (response.data.data.length > 0) {
						this.event_location =
							response.data.data[0].TAM_TNAME +
							" " +
							response.data.data[0].AMP_TNAME +
							" " +
							response.data.data[0].PROV_TNAME +
							" " +
							response.data.data[0].POSTCOD;
						this.event_location_id = response.data.data[0].ADMIN_CODE.slice(-6);
						//   console.log("this.event_location_id =",this.event_location_id);
						//   console.log(this.event_location);
						this.point.clearLayers();
						// L.marker(e.latlng).addTo(this.point).bindPopup(`ละติจูด : ${e.latlng.lat}`+'<br>'+`ลองจิจูด : ${e.latlng.lng}`+'<br>'+`สถานที่ : ${this.event_location}`).openPopup();
						L.marker(this.latlon).addTo(this.point).bindPopup(`ละติจูด : ${parseFloat(this.latlon.lat).toFixed(6)}`+'<br>'+`ลองจิจูด : ${parseFloat(this.latlon.lon).toFixed(6)}`+'<br>'+`สถานที่ : ${this.event_location}`).openPopup();
						this.map.setView(this.latlon,13)
						}
						
						});
				}
				// เพิ่ม มุดmap 3/3 จบ
		}
    },
	computed:{
		
	}
}
</script>

<style scoped>
#mapid{
    height: 500px;
}
</style>

